import { Jurisdiction } from '@models/jurisdictions';
import { MatterAdjustmentVacantTaxCalculated } from '@models/matter';
import { Selector } from '@ngxs/store';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { MatterJurisdictionSelectors } from '@state/matter/jurisdictions/jurisdictions.selectors';
import { SelectedMatter } from '@state/matter/matter.selectors';

export interface JurisdictionFieldState {
	matterId: string;
	showMlttToast: boolean;
	isLROToronto: boolean;
	primaryJurisdiction: Jurisdiction;
	hasVacantTaxJurisdiction: boolean;
	vacantTaxAdjustment: MatterAdjustmentVacantTaxCalculated;
	vacantTaxApplicableJurisdiction: Jurisdiction;
}
export class JurisdictionFieldSelector {
	@Selector([
		SelectedMatter.id,
		SelectedMatter.showMlttToast,
		SelectedMatter.isLROToronto,
		MatterJurisdictionSelectors.getPrimary,
		MatterJurisdictionSelectors.showVacantTaxCheckbox,
		AdjustmentsSelector.getVacantTaxAdjustmentCalculated,
		MatterJurisdictionSelectors.getVacantTaxApplicableJurisdiction,
	])
	static GetJurisdictionFieldState(
		matterId: string,
		showMlttToast: boolean,
		isLROToronto: boolean,
		primaryJurisdiction: Jurisdiction,
		hasVacantTaxJurisdiction: boolean,
		vacantTaxAdjustment: MatterAdjustmentVacantTaxCalculated,
		vacantTaxApplicableJurisdiction: Jurisdiction,
	): JurisdictionFieldState {
		return {
			matterId,
			showMlttToast,
			isLROToronto,
			primaryJurisdiction,
			hasVacantTaxJurisdiction,
			vacantTaxAdjustment,
			vacantTaxApplicableJurisdiction,
		};
	}
}
